import React from "react";

const UpIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="30">
    <path fill="#1cbe20" d="M20.402 11.579l-1.918.564a.34.34 0 01-.192-.651l2.885-.849a.34.34 0 01.435.326v3.054a.34.34 0 01-.679 0v-2.022l-4.139 5.617a.34.34 0 01-.57-.038l-1.784-3.27-3.756 5.008a.34.34 0 01-.543-.408l4.072-5.43a.34.34 0 01.57.041l1.781 3.266z"/>
    <path fill="none" stroke="#1cbe20" stroke-miterlimit="20" d="M20.402 11.579v0l-1.918.564a.34.34 0 01-.192-.651l2.885-.849a.34.34 0 01.435.326v3.054a.34.34 0 01-.679 0v-2.022 0l-4.139 5.617a.34.34 0 01-.57-.038l-1.784-3.27v0l-3.756 5.008a.34.34 0 01-.543-.408l4.072-5.43a.34.34 0 01.57.041l1.781 3.266v0z"/>
  </svg>
)

export default UpIcon;
